export default "__VITE_ASSET__5GvpIkDn__"